import React, { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faClock } from "@fortawesome/free-solid-svg-icons";
import { useTimeTracking } from "../../context/TimeTrackingContext";

const PreviousTaskNotification = () => {
  const history = useHistory();
  const location = useLocation();
  const { previousTaskInfo, dismissPreviousTaskNotification } =
    useTimeTracking();

  useEffect(() => {
    if (
      previousTaskInfo &&
      location.pathname === `/task/${previousTaskInfo.task_id}`
    ) {
      dismissPreviousTaskNotification();
    }
  }, [location.pathname, previousTaskInfo, dismissPreviousTaskNotification]);

  if (!previousTaskInfo) {
    return null;
  }

  const handleClick = () => {
    history.push(`/task/${previousTaskInfo.task_id}`);
    dismissPreviousTaskNotification();
  };

  const handleDismiss = (e) => {
    e.stopPropagation();
    dismissPreviousTaskNotification();
  };

  return (
    <div className="previous-task-notification" onClick={handleClick}>
      <div className="previous-task-notification-content">
        <FontAwesomeIcon icon={faClock} className="notification-icon" />
        <div className="notification-text">
          <div className="notification-title">Time tracking switched</div>
          <div className="notification-message">
            You were tracking time on:{" "}
            <strong>{previousTaskInfo.task_name}</strong>
          </div>
          <div className="notification-hint">Click to go to that task</div>
        </div>
        <button
          className="notification-close-btn"
          onClick={handleDismiss}
          aria-label="Dismiss notification"
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>
      </div>
    </div>
  );
};

export default PreviousTaskNotification;
